var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/tiered-navigation-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/tiered-navigation-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
output += "\n";
env.getTemplate("macros/navigation-items.j2", false, "core/templates/macros/tiered-navigation-macro.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("renderNavItem")) {
var t_8 = t_5.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_8);
output += "\n\n";
output += "\n\n";
var macro_t_9 = runtime.makeMacro(
["slugs"], 
["level", "levelLimit", "class"], 
function (l_slugs, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slugs", l_slugs);
frame.set("level", kwargs.hasOwnProperty("level") ? kwargs["level"] : 3);
frame.set("levelLimit", kwargs.hasOwnProperty("levelLimit") ? kwargs["levelLimit"] : 3);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_10 = "";t_10 += "\n\n    ";
t_10 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "level") <= runtime.contextOrFrameLookup(context, frame, "levelLimit")) {
t_10 += "\n\n        <ul class=\"";
t_10 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level", env.opts.autoescape);
t_10 += "-";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_10 += "\" data-qa-main-navigation data-qa-main-navigation-level-";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_10 += ">\n\n        ";
frame = frame.push();
var t_13 = l_slugs;
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("slug", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
t_10 += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_14)) {
t_10 += "\n\n                ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_14);
frame.set("navItem", t_15, true);
if(frame.topLevel) {
context.setVariable("navItem", t_15);
}
if(frame.topLevel) {
context.addExport("navItem", t_15);
}
t_10 += "\n\n                    ";
t_10 += runtime.suppressValue((lineno = 134, colno = 68, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_16 = runtime.makeMacro(
["currentNavItem", "url", "target"], 
[], 
function (l_currentNavItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("currentNavItem", l_currentNavItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_17 = "";t_17 += "\n\n                        ";
var t_18;
t_18 = ((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences") && runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences")),"displayAsSale") == runtime.contextOrFrameLookup(context, frame, "True")) && (runtime.memberLookup((l_currentNavItem),"nestLevel") < 3)?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isSaleLink", t_18, true);
if(frame.topLevel) {
context.setVariable("isSaleLink", t_18);
}
if(frame.topLevel) {
context.addExport("isSaleLink", t_18);
}
t_17 += "\n\n                        <li class=\"";
t_17 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isSaleLink")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__sale":""), env.opts.autoescape);
t_17 += " ";
t_17 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_17 += " ";
t_17 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li--level", env.opts.autoescape);
t_17 += "-";
t_17 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_17 += "\">\n\n                            ";
var t_19;
t_19 = (lineno = 143, colno = 63, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug")]));
frame.set("rootRelativePath", t_19, true);
if(frame.topLevel) {
context.setVariable("rootRelativePath", t_19);
}
if(frame.topLevel) {
context.addExport("rootRelativePath", t_19);
}
t_17 += "\n                            ";
var t_20;
t_20 = env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + runtime.contextOrFrameLookup(context, frame, "rootRelativePath")));
frame.set("canonicalUrl", t_20, true);
if(frame.topLevel) {
context.setVariable("canonicalUrl", t_20);
}
if(frame.topLevel) {
context.addExport("canonicalUrl", t_20);
}
t_17 += "\n                            ";
var t_21;
t_21 = "noopener noreferrer";
frame.set("rel", t_21, true);
if(frame.topLevel) {
context.setVariable("rel", t_21);
}
if(frame.topLevel) {
context.addExport("rel", t_21);
}
t_17 += "\n\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"isContainer")) {
t_17 += "\n\n                                <span class=\"";
t_17 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_17 += " ";
t_17 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_17 += " ";
t_17 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_17 += "-";
t_17 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_17 += "\">\n\n                                    ";
t_17 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_17 += "\n\n                                </span>\n\n                            ";
;
}
else {
t_17 += "\n\n                                <a ";
if(l_target) {
t_17 += "target=\"";
t_17 += runtime.suppressValue(l_target, env.opts.autoescape);
t_17 += "\" ";
if(l_target == "_blank") {
t_17 += " rel=\"";
t_17 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_17 += "\" ";
;
}
;
}
t_17 += "\n\n                                    ";
t_17 += runtime.suppressValue((lineno = 159, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 159, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_17 += "\n                                    class=\"";
t_17 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_17 += " ";
t_17 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_17 += "-";
t_17 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_17 += " ";
t_17 += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "level") == 1 && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) == 0)?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--no-children":""), env.opts.autoescape);
t_17 += "\" href=\"";
t_17 += runtime.suppressValue(l_url, env.opts.autoescape);
t_17 += "\"  data-qa-main-navigation-link>\n\n                                    <span class=\"";
t_17 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_17 += "\">";
t_17 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_17 += "</span>\n\n                                </a>\n\n                            ";
;
}
t_17 += "\n\n                        </li>\n\n                    ";
;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
return macro_t_16;})()})])), env.opts.autoescape);
t_10 += "\n\n            ";
;
}
t_10 += "\n\n        ";
;
}
}
frame = frame.pop();
t_10 += "\n\n        </ul>\n\n    ";
;
}
t_10 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("buildTieredPrimaryNavigationLevel3");
context.setVariable("buildTieredPrimaryNavigationLevel3", macro_t_9);
output += "\n\n";
var macro_t_22 = runtime.makeMacro(
["slugs"], 
["level", "levelLimit", "containerNavItem", "class"], 
function (l_slugs, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slugs", l_slugs);
frame.set("level", kwargs.hasOwnProperty("level") ? kwargs["level"] : 2);
frame.set("levelLimit", kwargs.hasOwnProperty("levelLimit") ? kwargs["levelLimit"] : 3);
frame.set("containerNavItem", kwargs.hasOwnProperty("containerNavItem") ? kwargs["containerNavItem"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_23 = "";t_23 += "\n\n    ";
t_23 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "level") <= runtime.contextOrFrameLookup(context, frame, "levelLimit")) {
t_23 += "\n\n        <ul class=\"";
t_23 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_23 += " ";
t_23 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level", env.opts.autoescape);
t_23 += "-";
t_23 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_23 += "\" data-qa-main-navigation data-qa-main-navigation-level-";
t_23 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_23 += ">\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "containerNavItem")) {
t_23 += "\n\n            <li class=\"";
t_23 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_23 += " ";
t_23 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li--level", env.opts.autoescape);
t_23 += "-";
t_23 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_23 += "\">\n\n                <span class=\"";
t_23 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_23 += " ";
t_23 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_23 += " ";
t_23 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_23 += "-";
t_23 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_23 += "\">\n\n                    ";
t_23 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "containerNavItem")),"displayName"), env.opts.autoescape);
t_23 += "\n\n                </span>\n\n                ";
t_23 += runtime.suppressValue((lineno = 199, colno = 51, runtime.callWrap(macro_t_9, "buildTieredPrimaryNavigationLevel3", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "containerNavItem")),"childSlugs"),runtime.makeKeywordArgs({"class": runtime.contextOrFrameLookup(context, frame, "class")})])), env.opts.autoescape);
t_23 += "\n\n            </li>\n\n        ";
;
}
t_23 += "\n\n        ";
frame = frame.push();
var t_26 = l_slugs;
if(t_26) {var t_25 = t_26.length;
for(var t_24=0; t_24 < t_26.length; t_24++) {
var t_27 = t_26[t_24];
frame.set("slug", t_27);
frame.set("loop.index", t_24 + 1);
frame.set("loop.index0", t_24);
frame.set("loop.revindex", t_25 - t_24);
frame.set("loop.revindex0", t_25 - t_24 - 1);
frame.set("loop.first", t_24 === 0);
frame.set("loop.last", t_24 === t_25 - 1);
frame.set("loop.length", t_25);
t_23 += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_27)) {
t_23 += "\n\n                ";
var t_28;
t_28 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_27);
frame.set("navItem", t_28, true);
if(frame.topLevel) {
context.setVariable("navItem", t_28);
}
if(frame.topLevel) {
context.addExport("navItem", t_28);
}
t_23 += "\n\n                    ";
t_23 += runtime.suppressValue((lineno = 211, colno = 68, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_29 = runtime.makeMacro(
["currentNavItem", "url", "target"], 
[], 
function (l_currentNavItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("currentNavItem", l_currentNavItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_30 = "";t_30 += "\n\n                        ";
var t_31;
t_31 = ((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences") && runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences")),"displayAsSale") == runtime.contextOrFrameLookup(context, frame, "True")) && (runtime.memberLookup((l_currentNavItem),"nestLevel") < 3)?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isSaleLink", t_31, true);
if(frame.topLevel) {
context.setVariable("isSaleLink", t_31);
}
if(frame.topLevel) {
context.addExport("isSaleLink", t_31);
}
t_30 += "\n                        ";
var t_32;
t_32 = "noopener noreferrer";
frame.set("rel", t_32, true);
if(frame.topLevel) {
context.setVariable("rel", t_32);
}
if(frame.topLevel) {
context.addExport("rel", t_32);
}
t_30 += "\n\n                        <li class=\"";
t_30 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isSaleLink")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__sale":""), env.opts.autoescape);
t_30 += " ";
t_30 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_30 += " ";
t_30 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li--level", env.opts.autoescape);
t_30 += "-";
t_30 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_30 += "\">\n\n                            ";
var t_33;
t_33 = (lineno = 221, colno = 63, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug")]));
frame.set("rootRelativePath", t_33, true);
if(frame.topLevel) {
context.setVariable("rootRelativePath", t_33);
}
if(frame.topLevel) {
context.addExport("rootRelativePath", t_33);
}
t_30 += "\n                            ";
var t_34;
t_34 = env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + runtime.contextOrFrameLookup(context, frame, "rootRelativePath")));
frame.set("canonicalUrl", t_34, true);
if(frame.topLevel) {
context.setVariable("canonicalUrl", t_34);
}
if(frame.topLevel) {
context.addExport("canonicalUrl", t_34);
}
t_30 += "\n\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"isContainer")) {
t_30 += "\n\n                                <span class=\"";
t_30 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_30 += " ";
t_30 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_30 += " ";
t_30 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_30 += "-";
t_30 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_30 += "\">\n\n                                    ";
t_30 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_30 += "\n\n                                </span>\n\n                            ";
;
}
else {
t_30 += "\n\n                                <a ";
if(l_target) {
t_30 += "target=\"";
t_30 += runtime.suppressValue(l_target, env.opts.autoescape);
t_30 += "\" ";
if(l_target == "_blank") {
t_30 += " rel=\"";
t_30 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_30 += "\" ";
;
}
;
}
t_30 += "\n\n                                    ";
t_30 += runtime.suppressValue((lineno = 236, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 236, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_30 += "\n                                    class=\"";
t_30 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_30 += " ";
t_30 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_30 += "-";
t_30 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_30 += " ";
t_30 += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "level") == 1 && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) == 0)?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--no-children":""), env.opts.autoescape);
t_30 += "\" href=\"";
t_30 += runtime.suppressValue(l_url, env.opts.autoescape);
t_30 += "\" data-qa-main-navigation-link>\n\n                                    <span class=\"";
t_30 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_30 += "\">";
t_30 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_30 += "</span>\n\n                                </a>\n\n                            ";
;
}
t_30 += "\n\n                            ";
t_30 += "\n                            ";
if(runtime.contextOrFrameLookup(context, frame, "level") == 2 && runtime.memberLookup((l_currentNavItem),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) > 0) {
t_30 += "\n\n                                ";
t_30 += runtime.suppressValue((lineno = 248, colno = 67, runtime.callWrap(macro_t_9, "buildTieredPrimaryNavigationLevel3", context, [runtime.memberLookup((l_currentNavItem),"childSlugs"),runtime.makeKeywordArgs({"class": runtime.contextOrFrameLookup(context, frame, "class")})])), env.opts.autoescape);
t_30 += "\n\n                            ";
;
}
t_30 += "\n\n                        </li>\n\n                    ";
;
frame = frame.pop();
return new runtime.SafeString(t_30);
});
return macro_t_29;})()})])), env.opts.autoescape);
t_23 += "\n\n            ";
;
}
t_23 += "\n\n        ";
;
}
}
frame = frame.pop();
t_23 += "\n\n        </ul>\n\n    ";
;
}
t_23 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_23);
});
context.addExport("buildTieredPrimaryNavigationLevel2");
context.setVariable("buildTieredPrimaryNavigationLevel2", macro_t_22);
var macro_t_35 = runtime.makeMacro(
["slugs"], 
["level", "levelLimit", "selectedLevel1Slug", "class"], 
function (l_slugs, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slugs", l_slugs);
frame.set("level", kwargs.hasOwnProperty("level") ? kwargs["level"] : 1);
frame.set("levelLimit", kwargs.hasOwnProperty("levelLimit") ? kwargs["levelLimit"] : 3);
frame.set("selectedLevel1Slug", kwargs.hasOwnProperty("selectedLevel1Slug") ? kwargs["selectedLevel1Slug"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_36 = "";t_36 += "\n\n    ";
t_36 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "level") <= runtime.contextOrFrameLookup(context, frame, "levelLimit")) {
t_36 += "\n\n    ";
var t_37;
t_37 = ((runtime.contextOrFrameLookup(context, frame, "level") == 1)?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("islevelOne", t_37, true);
if(frame.topLevel) {
context.setVariable("islevelOne", t_37);
}
if(frame.topLevel) {
context.addExport("islevelOne", t_37);
}
t_36 += "\n    ";
var t_38;
t_38 = (runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"),(lineno = 289, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"categoryRootNavSlugs",{}])))?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("hasSubnav", t_38, true);
if(frame.topLevel) {
context.setVariable("hasSubnav", t_38);
}
if(frame.topLevel) {
context.addExport("hasSubnav", t_38);
}
t_36 += "\n\n        <ul class=\"";
t_36 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_36 += " ";
t_36 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level", env.opts.autoescape);
t_36 += "-";
t_36 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_36 += " ";
t_36 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "hasSubnav")?"has-subnav":""), env.opts.autoescape);
t_36 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_36 += "itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\"";
;
}
t_36 += " data-qa-main-navigation data-qa-main-navigation-level-";
t_36 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_36 += ">\n\n        ";
frame = frame.push();
var t_41 = l_slugs;
if(t_41) {var t_40 = t_41.length;
for(var t_39=0; t_39 < t_41.length; t_39++) {
var t_42 = t_41[t_39];
frame.set("slug", t_42);
frame.set("loop.index", t_39 + 1);
frame.set("loop.index0", t_39);
frame.set("loop.revindex", t_40 - t_39);
frame.set("loop.revindex0", t_40 - t_39 - 1);
frame.set("loop.first", t_39 === 0);
frame.set("loop.last", t_39 === t_40 - 1);
frame.set("loop.length", t_40);
t_36 += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_42)) {
t_36 += "\n\n                ";
var t_43;
t_43 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_42);
frame.set("navItem", t_43, true);
if(frame.topLevel) {
context.setVariable("navItem", t_43);
}
if(frame.topLevel) {
context.addExport("navItem", t_43);
}
t_36 += "\n\n                    ";
t_36 += runtime.suppressValue((lineno = 299, colno = 68, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_44 = runtime.makeMacro(
["currentNavItem", "url", "target"], 
[], 
function (l_currentNavItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("currentNavItem", l_currentNavItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_45 = "";t_45 += "\n\n                        ";
var t_46;
t_46 = ((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences") && runtime.memberLookup((runtime.memberLookup((l_currentNavItem),"navigationDisplayPreferences")),"displayAsSale") == runtime.contextOrFrameLookup(context, frame, "True")) && (runtime.memberLookup((l_currentNavItem),"nestLevel") < 3)?runtime.contextOrFrameLookup(context, frame, "True"):"");
frame.set("isSaleLink", t_46, true);
if(frame.topLevel) {
context.setVariable("isSaleLink", t_46);
}
if(frame.topLevel) {
context.addExport("isSaleLink", t_46);
}
t_45 += "\n                        ";
var t_47;
t_47 = "noopener noreferrer";
frame.set("rel", t_47, true);
if(frame.topLevel) {
context.setVariable("rel", t_47);
}
if(frame.topLevel) {
context.addExport("rel", t_47);
}
t_45 += "\n\n                        <li class=\"";
t_45 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isSaleLink")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__sale":""), env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li--level", env.opts.autoescape);
t_45 += "-";
t_45 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_45 += "\">\n\n                            ";
var t_48;
t_48 = (lineno = 309, colno = 63, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug")]));
frame.set("rootRelativePath", t_48, true);
if(frame.topLevel) {
context.setVariable("rootRelativePath", t_48);
}
if(frame.topLevel) {
context.addExport("rootRelativePath", t_48);
}
t_45 += "\n                            ";
var t_49;
t_49 = env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + runtime.contextOrFrameLookup(context, frame, "rootRelativePath")));
frame.set("canonicalUrl", t_49, true);
if(frame.topLevel) {
context.setVariable("canonicalUrl", t_49);
}
if(frame.topLevel) {
context.addExport("canonicalUrl", t_49);
}
t_45 += "\n\n                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"isContainer")) {
t_45 += "\n\n                                <span class=\"";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_45 += "-";
t_45 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_45 += "\">\n\n                                    ";
t_45 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_45 += "\n\n                                </span>\n\n                            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "level") == 1 && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) > 0) {
t_45 += "\n\n                                <a\n                                    ";
t_45 += runtime.suppressValue((lineno = 323, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 323, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_45 += "\n                                    class=\"";
t_45 += runtime.suppressValue(((t_42 == runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"))?"is-selected":""), env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_45 += "-";
t_45 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_45 += "\" href=\"";
t_45 += runtime.suppressValue(l_url, env.opts.autoescape);
t_45 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_45 += "itemprop=\"url\"";
;
}
t_45 += " data-qa-main-navigation-link>\n\n                                    <span class=\"";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_45 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_45 += "itemprop=\"name\"";
;
}
t_45 += ">";
t_45 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_45 += "</span>\n\n                                </a>\n\n                            ";
;
}
else {
t_45 += "\n\n                                <a ";
if(l_target) {
t_45 += "target=\"";
t_45 += runtime.suppressValue(l_target, env.opts.autoescape);
t_45 += "\" ";
if(l_target == "_blank") {
t_45 += " rel=\"";
t_45 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_45 += "\" ";
;
}
;
}
t_45 += "\n\n                                    ";
t_45 += runtime.suppressValue((lineno = 334, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 334, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_45 += "\n                                    class=\"";
t_45 += runtime.suppressValue(((t_42 == runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"))?"is-selected":""), env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--level", env.opts.autoescape);
t_45 += "-";
t_45 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_45 += " ";
t_45 += runtime.suppressValue(((runtime.contextOrFrameLookup(context, frame, "level") == 1 && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) == 0)?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--no-children":""), env.opts.autoescape);
t_45 += "\" href=\"";
t_45 += runtime.suppressValue(l_url, env.opts.autoescape);
t_45 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_45 += "itemprop=\"url\"";
;
}
t_45 += " data-qa-main-navigation-link>\n\n                                    <span class=\"";
t_45 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span", env.opts.autoescape);
t_45 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_45 += "itemprop=\"name\"";
;
}
t_45 += ">";
t_45 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_45 += "</span>\n\n                                </a>\n\n                            ";
;
}
;
}
t_45 += "\n\n                        </li>\n\n                    ";
;
frame = frame.pop();
return new runtime.SafeString(t_45);
});
return macro_t_44;})()})])), env.opts.autoescape);
t_36 += "\n\n            ";
;
}
t_36 += "\n\n        ";
;
}
}
frame = frame.pop();
t_36 += "\n\n        </ul>\n\n    ";
;
}
t_36 += "\n\n    ";
t_36 += "\n    ";
if((runtime.contextOrFrameLookup(context, frame, "level") == 1 && runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"),l_slugs))) {
t_36 += "\n        ";
var t_50;
t_50 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"));
frame.set("selectedNavItem", t_50, true);
if(frame.topLevel) {
context.setVariable("selectedNavItem", t_50);
}
if(frame.topLevel) {
context.addExport("selectedNavItem", t_50);
}
t_36 += "\n\n        ";
t_36 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "selectedNavItem")) {
t_36 += "\n            ";
var t_51;
t_51 = (env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedNavItem")),"containerInfo")) > 0?runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedNavItem")),"containerInfo")),0):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("selectedFeatureSlug", t_51, true);
if(frame.topLevel) {
context.setVariable("selectedFeatureSlug", t_51);
}
if(frame.topLevel) {
context.addExport("selectedFeatureSlug", t_51);
}
t_36 += "\n        ";
;
}
t_36 += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "selectedFeatureSlug")) {
t_36 += "\n            ";
var t_52;
t_52 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.contextOrFrameLookup(context, frame, "selectedFeatureSlug")) || runtime.contextOrFrameLookup(context, frame, "None");
frame.set("containerNavItem", t_52, true);
if(frame.topLevel) {
context.setVariable("containerNavItem", t_52);
}
if(frame.topLevel) {
context.addExport("containerNavItem", t_52);
}
t_36 += "\n        ";
;
}
t_36 += "\n\n        ";
t_36 += runtime.suppressValue((lineno = 368, colno = 43, runtime.callWrap(macro_t_22, "buildTieredPrimaryNavigationLevel2", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "selectedNavItem")),"childSlugs"),runtime.makeKeywordArgs({"containerNavItem": runtime.contextOrFrameLookup(context, frame, "containerNavItem"),"class": runtime.contextOrFrameLookup(context, frame, "class")})])), env.opts.autoescape);
t_36 += "\n\n    ";
;
}
t_36 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_36);
});
context.addExport("buildTieredPrimaryNavigation");
context.setVariable("buildTieredPrimaryNavigation", macro_t_35);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/tiered-navigation-macro.j2"] , dependencies)